import React from "react";
import CustomModal from "../CustomModal/CustomModal";
import GeneralButton from "../SaveButton/GeneralButton";

const Fido2DomainResetModal = ({ open, affectedUsers, onConfirm, onCancel }) => (
  <CustomModal open={open} handleClose={onCancel} width="480px">
    <div className="p-2">
      <h3 className="main-heading mb-3">Remove FIDO2 / Biometric Devices?</h3>
      <p>
        {affectedUsers} user(s) in your organisation have FIDO2 / Biometric MFA
        configured. Changing the domain will remove all registered FIDO2 devices.
        Users will need to re-register their biometric authenticator on the new domain.
      </p>
      <p>Do you want to continue?</p>
      <div className="d-flex justify-content-end gap-2 mt-4">
        <GeneralButton type="button" variant="outlined" value="Cancel" onClickEvent={onCancel} />
        <GeneralButton type="button" variant="contained" value="Yes, Change Domain" onClickEvent={onConfirm} />
      </div>
    </div>
  </CustomModal>
);

export default Fido2DomainResetModal;
